import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Save } from 'lucide-react';

export const Field = ({ name, label, value, onChange, type = 'text', ...props }) => (
  <div className="min-w-0 space-y-2">
    <Label htmlFor={`benefit-${name}`}>{label}</Label>
    <Input id={`benefit-${name}`} data-testid={`benefit-${name}`} type={type} value={value ?? ''}
      onChange={e => onChange(e.target.value)} {...props} />
  </div>
);
export const Reason = ({ value, onChange }) => <div className="space-y-2">
  <Label htmlFor="benefit-reason">Written reason</Label>
  <Textarea id="benefit-reason" data-testid="benefit-reason" required minLength={10} maxLength={1000}
    value={value} onChange={e => onChange(e.target.value)} />
</div>;
export const SaveButton = ({ busy }) => <Button data-testid="benefit-save" type="submit" disabled={busy}>
  <Save className="h-4 w-4 mr-2" />{busy ? 'Saving…' : 'Save changes'}
</Button>;

export const BenefitSettingsForm = ({ settings, onSave, busy }) => {
  const [values, setValues] = useState(settings);
  const [reason, setReason] = useState('');
  const change = (kind, key, value) => setValues(v => ({...v, [kind]: {...v[kind], [key]: value}}));
  return <form className="space-y-6" onSubmit={e => {e.preventDefault(); const payload = {version: settings.version, reason};
    ['ticket','exit_reentry'].forEach(kind => {const v = values[kind]; payload[kind] = {entitled: v.entitled,
      frequency_years: v.entitled ? Number(v.frequency_years) : null, initial_due_date: v.entitled ? v.initial_due_date : null};}); onSave(payload);}}>
    {['ticket','exit_reentry'].map(kind => <section className="space-y-4 border-b pb-5" key={kind}>
      <label className="flex items-center gap-3 font-medium"><input data-testid={`${kind}-entitled`} type="checkbox" checked={values[kind]?.entitled || false}
        onChange={e => change(kind, 'entitled', e.target.checked)} />{kind === 'ticket' ? 'Flight ticket entitlement' : 'Exit re-entry entitlement'}</label>
      {values[kind]?.entitled && <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Field name={`${kind}-frequency`} label="Every (years)" type="number" min={1} max={100} step={1} required value={values[kind].frequency_years} onChange={v => change(kind,'frequency_years',v)} />
        <Field name={`${kind}-initial-due`} label="Initial next-due date" type="date" required value={values[kind].initial_due_date} onChange={v => change(kind,'initial_due_date',v)} />
      </div>}
    </section>)}<Reason value={reason} onChange={setReason} /><SaveButton busy={busy} />
  </form>;
};